export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.15-1148.57",
  commitId: "dd6c3afe27c09469baf6d6139645ef1980af52ef",
  commitTime: "2026-07-15T11:48:57.000Z",
});
